<template>
  <v-card class="d-flex align-center my-0 py-6 px-4" elevation="0">
    <div style="width: 100%">
      <v-card-title class="main-title">
        <v-icon
          v-if="haveBack"
          color="normalred"
          style="cursor: pointer"
          @click="voltar('/product-resale')"
          class="mr-2 ma-0 pa-0"
          size="26"
        >
          mdi-arrow-left
        </v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text class="card-text">{{ text }} </v-card-text>
    </div>

    <div>
      <div class="d-flex-column container">
        <v-btn
          class="
            header-button
            hidden-sm-and-down
            align-items-center
            pl-0
            max-width:
            145px
          "
          style="border-radius: 10px width: 200px"
          v-if="haveAction"
          color="normalred"
          elevation="0"
          @click="action"
          >{{ actionTitle }}</v-btn
        >

        <v-btn
          fab
          tile
          small
          style="border-radius: 6px box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);"
          class="header-button hidden-md-and-up"
          v-if="haveAction"
          color="normalred"
          elevation="2"
          @click="action"
        >
          <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>

      <slot></slot>
    </div>
  </v-card>
</template>

<style scoped>
.main-title {
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  line-height: 35px;
  color: #000000;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 35px;

  width: 70%;

  color: #9c9c9c;
}
.v-btn {
  font-weight: bold;
  width: 250px;
  border-radius: 10px;
  height: 50px;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

/* .container {
	max-width: 172px;
	margin: 0 auto;
	border: 1px solid rgb(19, 18, 18);
} */

@media (max-width: 900px) {
  .card-text {
    font-size: 1rem;
    width: 80%;
  }
}
</style>

<script>
export default {
  name: "HeaderCard",

  data: () => ({}),
  props: {
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
    haveBack: Boolean,
    mainPage: Boolean,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },

    action3() {
      this.$emit("action3");
    },

    async voltar(item) {
      await this.$router.go(-1);
    },
  },
};
</script>
